module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.129c5057.ttf";